export default __webpack_public_path__ + "aec17ec2c7b2fe634a240a1b7bb25d57.svg";